// GuidesView.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import l from "components/util/l";

const GuidesView = ({ tutorials, tutorialCategories }) => {
  const [hoveredId, setHoveredId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");

  const cats = new Set(tutorialCategories.map(c => c.name));
  if (tutorials.some(t => !t.categoryId)) cats.add("Sin Categoría");
  const allCats = ["Todas", ...cats];

  const filtered = tutorials.filter(t => {
    const name = t.categoryId?.name || "Sin Categoría";
    return !selectedCategory || name === selectedCategory;
  });

  return (
    <div className="h-100 overflow-auto p-3">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="m-0">{l("Guías%SA014")}</h2>
        <select
          className="form-select w-auto"
          value={selectedCategory}
          onChange={e => setSelectedCategory(e.target.value)}
        >
          {allCats.map(cat => (
            <option key={cat} value={cat === l("Todas%SA247") ? "" : cat}>
              {cat}
            </option>
          ))}
        </select>
      </div>

      <div className="row g-3">
        {filtered.map(t => (
          <div key={t.id} className="col-12 col-md-6 col-lg-4">
            <div
              className="card h-100"
              onMouseEnter={() => setHoveredId(t.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <div className="position-relative">
                <img
                  src={t.thumbnailPath}
                  alt={t.name}
                  className="card-img-top object-fit-cover"
                  style={{ height: "140px" }}
                />
                {hoveredId === t.id && (
                  <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex align-items-center justify-content-center rounded-top">
                    <Link
                      to={`/guides/${t.id}`}
                      className="btn btn-outline-light fw-bold"
                    >
                      <i className="fas fa-play me-2"></i>{l("Ver%GA038")}
                    </Link>
                  </div>
                )}
              </div>
              <div className="card-body">
                <h5 className="card-title text-truncate">{t.name}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GuidesView;
